import React, { useState } from "react";
import { connect } from "react-redux";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import * as Yup from "yup";
import EmailAuthenticationForm from "./EmailAuthenticationForm";
import appTranslations from "../sc-translate/appTranslations";
import { Tooltip, IconButton } from "@material-ui/core";
import { Help, Chat } from "@material-ui/icons";

const styles = theme => ({
    main: {
        width: "auto",
        display: "block", // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(6))]: {
            width: 400,
            marginLeft: "auto",
            marginRight: "auto"
        }
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        height: 500,
        alignItems: "center",
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
    },
    logo: {
        width: "250px",
        margin: "10px"
    },
    form: {
        width: "100%",
        marginTop: theme.spacing()
    },
    helpDeskStyle: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: theme.spacing(3)
    },
    message: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1),
        textAlign: 'center'
    },
    message2: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'center'
    },
    message3: {
        marginTop: theme.spacing(16),
        marginBottom: theme.spacing(5),
        textAlign: 'center'
    }
});

const getBrowserLanguage = () => {
    return navigator.language.length > 2 ? navigator.language.substring(0, 2) : navigator.language;
};
const EmailAuthentication = props => {
    const { classes, translations, socket } = props;

    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleLanguageChange = e => {
        e.preventDefault();
        socket.emit("get-translations", { LanguageKey: e.target.value });
    };
    let language = appTranslations.filter(language => language.code === getBrowserLanguage())
    let initialValues = {
        Email: "",
        language: language[0] ? language[0].code : 'en'
    };

    let formSettings = {
        Validation: {
            Email: Yup.string()
                .email("Invalid email")
                .required("Required"),
        },
        ButtonSubmit: {
            Title: translations["enter"] || "Enter",
            Color: "primary"
        },
    };

    const handleSubmit = () => {
        setIsSubmitted(true);
    }
    return (
        <main className={classes.main}>
            <CssBaseline />
            <Paper className={classes.paper}>
                <img
                    alt="App logo"
                    className={classes.logo}
                    src={props.logoPath ? process.env.PUBLIC_URL + props.logoPath : process.env.PUBLIC_URL + "/assets/images/app-logo.svg"}
                />
                {!isSubmitted ? (<>
                    <Typography component="h6" variant="h6" className={classes.message}>
                        {translations['welcome'] || 'Welcome'} {'!'}
                    </Typography>
                    <Typography component="h3" variant="h6" className={classes.message2} >
                        {translations['email_auth_message'] || 'To activate your pre-registration for Securaze erasure please enter your email address'} {':'}
                    </Typography> </>) :
                    <Typography className={classes.message3} component="h1" variant="h6">
                        {translations['submitted_message'] || 'Please check your mail, you’ll get instructions, if the email address entered is eligible for using Securaze.'}
                    </Typography>}
                {!isSubmitted ? <EmailAuthenticationForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    isSubmitted={isSubmitted}
                    translations={translations}
                    appTranslations={appTranslations}
                    handleLanguageChange={handleLanguageChange}
                >
                </EmailAuthenticationForm> : null}
                <div className={classes.helpDeskStyle}>
                    <Tooltip title={translations["help_desk"] || "Help desk"}>
                        <IconButton target="_blank" href="https://twentoo.ladesk.com/" color="inherit">
                            <Help />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={translations["contact_live_chat"] || "Contact/Live Chat"}>
                        <IconButton color="inherit" onClick={() => {
                            window.chatButton.onClick();
                        }}>
                            <Chat />
                        </IconButton>
                    </Tooltip>
                </div>
            </Paper>
        </main>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(mapStateToProps, null)(withStyles(styles)(EmailAuthentication));
